module.exports = __webpack_public_path__ + "assets/doubleclick-floodlight.e28e2913.svg";